import {
  LOAD_COMPARE,
  LOAD_DISCOUNT,
  UPDATE_CART,
  GET_POST,
  LOAD_BLOGS,
  GET_ARTICLE
} from './types';

import * as pageSvc from 'services/pages.svc';
import * as blogSvc from 'services/blog.service'
import * as articleSvc from 'services/article.service';

export const loadCompareData = (cat, type) => ({
  type: LOAD_COMPARE,
  payload: {
    promise: pageSvc.loadComparePageData(cat, type),
    cat,
    type
  }
});

export const loadDiscountData = (type) => ({
  type: LOAD_DISCOUNT,
  payload: {
    promise: pageSvc.getDiscountPageData(type),
    type
  }
});

export const updateCart = (data) => ({
  type: UPDATE_CART,
  payload: data
});

export const loadBlogPosts = (query) => ({
  type: LOAD_BLOGS,
  payload: {
    promise: blogSvc.getBlogs(query)
  }
});

export const getBlogPost = (slug) => ({
  type: GET_POST,
  payload: {
    promise: blogSvc.getPostBySlug(slug)
  }
});

export const getArticle = (type, brand) => ({
  type: GET_ARTICLE,
  payload: {
    promise: articleSvc.getArticle(type, brand),
    type
  },
});
